import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import {
  Grid,
  Divider as MuiDivider,
  Box,
  DialogActions,
  Button,
  CircularProgress,
  Typography as MuiTypography,
} from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";

import useUser from "../../../../hooks/useUser";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import { useDialog } from "../../../../contexts/DialogContext";

function PaidToUnpaid(props) {
  const { renewId, refreshPage } = props;

  const { updatePaidToUnpaid, isSubmitting } = useUser();
  const dispatch = useDispatch();
  const { unSetDialog, openDialog } = useDialog();

  const methods = useForm();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      await updatePaidToUnpaid(renewId);
      dispatch(showSuccessSnackbar("Invoice status updated successfully!"));
      refreshPage();
      unSetDialog("paid_to_unpaid");
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to change status"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to change paid to unpaid ?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("paid_to_unpaid")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default PaidToUnpaid;
